





























































































import {Vue, Component} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import {GetPartnersRequest,GetAdminsServiceMerchandisersResponse, Mall, Mds, Partner, SearchType, PartnerStatus, GetMallsResponse} from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import PartnerSelectBox from '@/components/partner/PartnerSelectBox.vue';
import FormButton from '@/components/common/FormButton.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import {i18nInObjectList} from '@/utils/i18n';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import countrys from '@/const/words/country';
import {getToday, addMonth, getDownToday} from '@/utils/dateUtils';
import {ncpPopup} from '@/utils/ncp';
import getMergedRowsBy from '@/utils/grid/rowMerger'
import {KeyMap, MergedRowData} from '@/types/tui-grid/utils/rowMerger';
import emojiRegexp from '@/utils/emojiRegexp';
import { createExcel } from '@/components/common/grid/ExcelCreateUtil';
import { DEFAULT_DATE_RANGE, DEFAULT_TIME_RANGE } from '@/pro/components/common/datepicker/dateRange';

const mallModule = namespace('mall');

@Component({
  components: {
    CompSelectBox,
    CompRadioButton,
    FormButton,
    PageTitle,
    PeriodDateCalendar,
    PartnerSelectBox,
    ItemTable
  }
})
export default class PartnerList extends Vue {
  @State private view!: object;
  @mallModule.Getter('malls')
  private malls!: Mall[];
  @mallModule.Getter('mallsMds')
  private mallsMds!: Mds[];
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<GetMallsResponse>;
  @mallModule.Action('fetchMallsMds') fetchMallsMds!: (mdsRequest) => Promise<GetAdminsServiceMerchandisersResponse>;
  
  private mds:Mds[] = [];
  private partners: Partner[] = [];
  private page: number = 1;
  private pageSize: number = 30;
  private totalCount:number = 0;
  private mallNo:number = 0;
  private chargeMdNo:number = 0;


  private keyword: string = '';
  private startYmd: string = addMonth(new Date(), -3);
  private endYmd: string = getToday();

  // ====== For grid ========
  private gridProps = {
    columns: [
      {
        header: 'PARTNER_PARTNER_LIST_PARTNERNO',
        name: 'partnerNo',
        align: 'center',
        minWidth: 180
      },
      {
        header: 'PARTNER_PARTNER_LIST_PARTNERNAME',
        name: 'partnerName',
        width: 180,
        align: 'center',
        formatter(partners: any) {
          return `<a href="/partner/modification-prev/${partners.row.partnerNo}">${partners.row.partnerName}</a>`;
        }
      },
      {
        header: 'PARTNER_PARTNER_LIST_COUNTRY',
        name: 'countryCode',
        align: 'center',
        minWidth: 60,
        formatter(partners: any) {
          const cell = partners.row.countryCode;
          for (var i = 0; i < countrys.length; i++) {
            if (countrys[i].value === cell) {
              return countrys[i].name;
            }
          }
        },
        copyOptions: {
          useFormattedValue: true
        },
      },
      {
        header: 'PARTNER_PARTNER_LIST_COMPANYNAME',
        name: 'companyName',
        align: 'center',
        minWidth: 120
      },
      {
        header: 'PARTNER_PARTNER_LIST_PARTNERSTATUS',
        name: 'partnerStatus',
        align: 'center',
        minWidth: 110,
        formatter(partners: any) {
          switch (partners.row.partnerStatus) {
            case 'ACTIVE':
              return window.$t('PARTNER_PARTNER_LIST_ACTIVE');
            case 'INVESTIGATION':
              return window.$t('PARTNER_PARTNER_LIST_INVESTIGATION');
            case 'WAITING':
              return window.$t('PARTNER_PARTNER_LIST_WAITING');
            default:
              return window.$t('PARTNER_PARTNER_LIST_NOSTATUS');
          }
        },
        copyOptions: {
          useFormattedValue: true
        },
      },
      {
        header: 'PARTNER_PARTNER_LIST_REGISTRATIONNO',
        name: 'registrationNo',
        align: 'center',
        minWidth: 120,
        formatter(partners: any) {
          return partners.row.business.registrationNo;
        }
      },
      {
        header: 'PARTNER_PARTNER_LIST_OMDNO',
        name: 'onlineMarketingDeclarationNo',
        align: 'center',
        minWidth: 180,
        formatter(partners: any) {
          return partners.row.business.onlineMarketingDeclarationNo;
        }
      },
	    {
				header: 'PARTNER_PARTNER_LIST_MALL_NAME',
		    name: 'mallName',
		    align: 'center',
		    minWidth: 100,
	    },
      {
        header: 'PARTNER_PARTNER_LIST_CONTRACT_STATUS',
        name: 'contractStatus',
        align: 'center',
        minWidth: 100,
        formatter({ value }) {
          switch (value) {
            case 'ACTIVE':
              return window.$t('PARTNER_PARTNER_LIST_CONTRACT_STATUS_ACTIVE');
            case 'INVESTIGATION':
              return window.$t('PARTNER_PARTNER_LIST_CONTRACT_STATUS_INVESTIGATION');
            case 'WAITING':
              return window.$t('PARTNER_PARTNER_LIST_CONTRACT_STATUS_WAITING');
            case 'SUSPEND':
              return window.$t('PARTNER_PARTNER_LIST_CONTRACT_STATUS_SUSPEND');
            default:
              return window.$t('PARTNER_PARTNER_LIST_NOSTATUS');
          }
        },
        copyOptions: {
          useFormattedValue: true
        },
      },
	    {
		    header: 'PARTNER_PARTNER_LIST_PRODUCTREGISTERED',
		    name: 'productRegistered',
		    align: 'center',
		    minWidth: 60,
		    formatter(partners: any) {
			    if (partners.row.productRegistered) {
				    return window.$t('PARTNER_PARTNER_LIST_TRUE');
			    } else {
				    return window.$t('PARTNER_PARTNER_LIST_FALSE');
			    }
		    },
		    copyOptions: {
			    useFormattedValue: true
		    },
	    },
	    {
		    header: 'PARTNER_PARTNER_LIST_COMMISSION_RATE',
		    name: 'commissionRate',
		    align: 'center',
		    minWidth: 80,
		    formatter: ({ row, value }) => {
          if (row.usesDefaultCommissionRate) {
            return `${value}%`;
          }

          return window.$t('PARTNER_PARTNER_LIST_NOT_USED');
        },
        copyOptions: {
          useFormattedValue: true
        },
	    },
	    {
		    header: 'PARTNER_PARTNER_LIST_CREATED_DATE_TIME',
		    name: 'createdDateTime',
		    align: 'center',
		    minWidth: 140,
		    formatter(partners: any) {
			    // if (partners.row.partnerStatus === 'ACTIVE') {
				  //   return partners.row.createdDateTime;
			    // }
			    // return '-';
          return partners.row.createdDateTime ?? '-'
		    }
	    },
      {
        header: 'PARTNER_PARTNER_LIST_CONTRACTED_DATE_TIME',
        name: 'contractDateTime',
        align: 'center',
        minWidth: 140,
        formatter(partners: any) {
          // if (partners.row.partnerStatus === 'ACTIVE') {
          //   return partners.row.contractDateTime;
          // }
          // return '-';
          return partners.row.contractDateTime ?? '-'
        }
      }
    ],
    header: {
      height: 32
    },
    options: {
      rowHeaders: ['rowNum'],
      columnOptions: {
        resizable: true
      },
      minRowHeight: 31,
      rowHeight: 31,
      inBodyHeight: 190,
      bodyHeight: 480,
      minBodyHeight: 190,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0,
        visiblePages: 5
      }
    }
  };
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
	private partnerPeriodType = [
		{
			name: 'PARTNER_PARTNER_LIST_CREATED',
			value: 'CREATED',
		},
		{
			name: 'PARTNER_PARTNER_LIST_CONTRACT',
			value: 'CONTRACT',
		}
	];
  private searchType = [
    {
      searchTypeValue: 'ALL',
      searchTypeName: 'COMMON_ALL'
    },
    {
      searchTypeValue: 'PARTNER_NAME',
      searchTypeName: 'PARTNER_PARTNER_LIST_PARTNERNAME'
    },
    {
      searchTypeValue: 'PARTNER_NO',
      searchTypeName: 'PARTNER_PARTNER_LIST_PARTNERNO'
    },
    {
      searchTypeValue: 'COMPANY_NAME',
      searchTypeName: 'PARTNER_PARTNER_LIST_COMPANYNAME'
    },
    {
      searchTypeValue: 'REGISTRATION_NO',
      searchTypeName: 'PARTNER_PARTNER_LIST_REGISTRATIONNO'
    }
  ];
  private partnerStatusOptions = {
    name: 'partnerStatus',
    data: [
      {
        id: 'partnerStatus_1',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'partnerStatus_2',
        value: 'WAITING',
        dispaly: 'PARTNER_PARTNER_LIST_WAITING'
      },
      {
        id: 'partnerStatus_3',
        value: 'INVESTIGATION',
        dispaly: 'PARTNER_PARTNER_LIST_INVESTIGATION'
      },
      {
        id: 'partnerStatus_4',
        value: 'ACTIVE',
        dispaly: 'PARTNER_PARTNER_LIST_ACTIVE'
      }
    ]
  };
  private productRegisteredOptions = {
    name: 'hasProduct',
    data: [
      {
        id: 'has_product_all',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'has_product_true',
        value: true,
        dispaly: 'PARTNER_PARTNER_LIST_TRUE'
      },
      {
        id: 'has_product_false',
        value: false,
        dispaly: 'PARTNER_PARTNER_LIST_FALSE'
      }
    ]
  };

  private getPartnersRequest: GetPartnersRequest = {
    params: {
      mallNo: this.malls && this.malls.length && this.malls[0].mallNo,
      page: 1,
      pageSize: 30,
      searchType: 'ALL' as SearchType,
      partnerStatus: '' as PartnerStatus,
      chargeMdNo: 0,
      productRegistered: '' as any,
      keyword: '' as any,
	    // 계약일시 일정타입
	    periodType: 'CREATED',
	    startDateTime: '',
	    endDateTime: '',
    }
  };

  private mounted(): void {
    this.fetchMalls();
    this.init();
    if (this.malls.length === 1) {
      this.getInitMds();
    }
  }

  private init() {
    if (this.malls.length === 1) {
      this.getPartnersRequest = {
        params: {
          searchType: 'ALL',
          mallNo: this.malls[0].mallNo,
          partnerStatus: '' as PartnerStatus,
          chargeMdNo: 0,
          productRegistered: '',
          pageSize: 30,
          page: 1,
          keyword: '' as any,
					// 계약일시 일정타입
	        periodType: 'CREATED',
	        startDateTime: '',
	        endDateTime: '',
        }
      };
    } else {
      this.getPartnersRequest = {
        params: {
          searchType: 'ALL',
          mallNo: undefined,
          partnerStatus: '' as PartnerStatus,
          chargeMdNo: 0,
          productRegistered: '',
          pageSize: 30,
          page: 1,
          keyword: '' as any,
					// 계약일시 일정타입
	        periodType: 'CREATED',
	        startDateTime: '',
	        endDateTime: '',
        }
      };
    }
    this.keyword = ''
  }
  private reset() {
    if (this.malls.length === 1) {
      this.getPartnersRequest = {
        params: {
          searchType: 'ALL',
          mallNo: this.malls[0].mallNo,
          partnerStatus: '' as PartnerStatus,
          chargeMdNo: 0,
          productRegistered: '',
          pageSize: this.pageSize,
          page: 1,
          keyword: '' as any,
	        // 계약일시 일정타입
	        periodType: 'CREATED',
	        startDateTime: '',
	        endDateTime: '',
        }
      };
    } else {
      this.getPartnersRequest = {
        params: {
          searchType: 'ALL',
          mallNo: undefined,
          partnerStatus: '' as PartnerStatus,
          chargeMdNo: 0,
          productRegistered: '',
          pageSize: this.pageSize,
          page: 1,
          keyword: '' as any,
	        // 계약일시 일정타입
	        periodType: 'CREATED',
	        startDateTime: '',
	        endDateTime: '',
        }
      };
    }
    this.keyword = ''
    const tempVue: any = this.$refs.datePicker;
    tempVue.clickPeriod('3m');
  }
  private readonly periodOption = {
    name: 'periodOption',
    periodTypes: ['td', '1w', '1m', '3m', '6m', '1y', 'all'],
    period: '3m'
  };
  private ableValidity() {
    return this.getPartnersRequest.params.mallNo === undefined ? true : false;
  }
  private getInitMds() {
    this.onMallChange(this.malls[0].mallNo.toString());
  }
  private isSearchFormPassed() {
    if (this.getPartnersRequest.params.searchType !== 'ALL' && this.keyword.trim().length === 0) {
      alert(window.$t('PARTNER_PARTNER_LIST_PLEASE_INPUT'));
      return false;
    }
    return true;
  }

  private onPageSizeChange(page: number, pageSize: number) {
    this.page = page;
    if (pageSize) {
      this.pageSize = pageSize;
    }
    this.search(page);
  }
  private async search(page: number) {
    if (this.isSearchFormPassed()) {
      this.getPartnersRequest.params.pageSize = this.pageSize;
      this.getPartnersRequest.params.page = page;

      this.getPartnersRequest.params.keyword = this.keyword.trim();

      this.getPartnersRequest.params.startDateTime = `${!this.startYmd?.length ? DEFAULT_DATE_RANGE.MIN : this.startYmd} ${DEFAULT_TIME_RANGE.START}`;
      this.getPartnersRequest.params.endDateTime = `${!this.endYmd?.length ? DEFAULT_DATE_RANGE.MAX : this.endYmd} ${DEFAULT_TIME_RANGE.END}`;

      const getPartnersResponse = await this.$api.getPartners(this.getPartnersRequest);
      const {data} = getPartnersResponse;
      this.setData(data.contents, data.totalCount, page, this.pageSize, this.getPartnersRequest.params.mallNo, this.getPartnersRequest.params.chargeMdNo);
    }
  }
  private setData(partnersList: Partner[], totalCount: number, page: number, pageSize: number, mallNo:number, chargeMdNo:number) {
		const keyMap: KeyMap<Partner, any> = {
			partnerNo: [
				'partnerNo',
				'partnerName',
				'countryCode',
				'companyName',
				'partnerStatus',
				'registrationNo',
				'onlineMarketingDeclarationNo',
			],
			mallNo: ['mallName', 'productRegistered', 'contractDateTime']
		}
    this.partners = getMergedRowsBy<Partner, any>(partnersList as any as MergedRowData<Partner, any>[], keyMap);
    this.totalCount = totalCount;
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = pageSize;
    this.gridProps.options.pageOptions.totalCount = totalCount;
    this.mallNo = mallNo;
    this.chargeMdNo = chargeMdNo
  }
  private changedMdCallback() {
    this.search(1);
    sessionStorage.removeItem('md-info')
  }
  private handleChangeMdClick() {
      const partnerMdLength = this.partners.length;

      if(partnerMdLength === 0) {
        alert(this.$t('PARTNER_EDIT_NOT_FOUND_DATA'));
        return;
      }
      if(!this.mallNo || !this.chargeMdNo){ 
        alert(this.$t('PARTNER_EDIT_DISMATCH_MD_NO'))
        return;
        }
    
      const mallNo = this.mallNo;
      const chargeMdNo = this.chargeMdNo;
      (window as any).changedMdCallback = this.changedMdCallback;
      const url = `/partner/popup/change-md?mallNo=${mallNo}&chargeMdNo=${chargeMdNo}&callback=changedMdCallback`;
      sessionStorage.setItem('md-info', JSON.stringify(this.getPartnersRequest.params))
      ncpPopup(url, window.$t('PARTNER_EDIT_CHANGE_ADMIN'), 736, 550);
    }
  
  private contentBottomOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    excelDownInfo: {
      fileName: `partner_list_${getDownToday()}`,
      nameDateFormat: 'YYYYMMDD_HHmmss',
      columns: {
        partnerNo: 'PARTNER_PARTNER_LIST_PARTNERNO',
        partnerName: 'PARTNER_PARTNER_LIST_PARTNERNAME',
        countryCode: 'PARTNER_PARTNER_LIST_COUNTRY',
        companyName: 'PARTNER_PARTNER_LIST_COMPANYNAME',
        partnerStatus: 'PARTNER_PARTNER_LIST_PARTNERSTATUS',
        productRegistered: 'PARTNER_PARTNER_LIST_PRODUCTREGISTERED',
        registrationNo: 'PARTNER_PARTNER_LIST_REGISTRATIONNO',
        onlineMarketingDeclarationNo: 'PARTNER_PARTNER_LIST_OMDNO',
        createdDateTime: 'PARTNER_PARTNER_LIST_CREATEDDATETIME',
	      contractedDateTime: 'PARTNER_PARTNER_LIST_CONTRACTED_DATE_TIME'
      },
      limitSize: 10000,
      formatters: {
        countryCode: (cell: any) => {
          const cells = cell.row.countryCode;
          for (var i = 0; i < countrys.length; i++) {
            if (countrys[i].value === cells) {
              return countrys[i].name;
            }
          }
        },
        partnerStatus: (cell: any) => {
          if (cell.value == null) {
            return '';
          }
          return window.$t(`PARTNER_PARTNER_LIST_${cell.row.partnerStatus}`);
        },
        productRegistered: (cell: any) => {
          if (cell.value == null) {
            return '';
          } else if (cell.value == true) {
            return window.$t('PARTNER_PARTNER_LIST_TRUE');
          } else {
            return window.$t('PARTNER_PARTNER_LIST_FALSE');
          }
        },
        registrationNo: (cell: any) => {
          return cell.row.business.registrationNo;
        },
        onlineMarketingDeclarationNo: (cell: any) => {
          return cell.row.business.onlineMarketingDeclarationNo;
        },
        createdDateTime: (cell: any) => cell.value || '-',
	      contractDateTime: (cell: any) => {
		      if (cell.row.partnerStatus == 'ACTIVE') {
			      return cell.value;
		      }
		      return '-';
	      }
      }
    }
  };

  private changeOptionIndex() {
     const mallsMdsMap= this.mallsMds.map(({name, id, adminNo})=>({
      name: `${name}(${id})`,
      adminNo,
      id,
    }))
    this.mds = [...mallsMdsMap].sort((a,b)=>a.name>b.name?1:-1)
  }

  private async onMallChange(value: string) {
    if (value) {
      this.getPartnersRequest.params.chargeMdNo = 0;
      const mdsRequest = {
        params: {
          mallNo: value
        }
      };
      await this.fetchMallsMds(mdsRequest);
      this.changeOptionIndex()
      return
    } 
    this.getPartnersRequest.params.chargeMdNo = 0;
  }
  private handleExcelCreateClick() {
    const hasData = this.totalCount && this.totalCount > 0;
    if (!hasData) {
      alert(this.$t('COMMON_NOT_DATA'));
      return;
    }

    const requestParams = {
        searchType: this.getPartnersRequest.params.searchType,
        keyword: this.keyword.trim(),
        partnerStatus: this.getPartnersRequest.params.partnerStatus,
        mallNo: this.getPartnersRequest.params.mallNo,
        chargeMdNo: this.getPartnersRequest.params.chargeMdNo,
        startDateTime: `${!this.startYmd?.length ? DEFAULT_DATE_RANGE.MIN : this.startYmd} ${DEFAULT_TIME_RANGE.START}`,
        endDateTime: `${!this.endYmd?.length ? DEFAULT_DATE_RANGE.MAX : this.endYmd} ${DEFAULT_TIME_RANGE.END}`,
        productRegistered: this.getPartnersRequest.params.productRegistered,
        periodType: this.getPartnersRequest.params.periodType,
    };
    createExcel(this, hasData, requestParams,'PREMIUM_PARTNER_LIST', this.getPartnersRequest.params.chargeMdNo.toString());
  }

  private removeEmoji(){
    this.keyword = this.keyword.replace(emojiRegexp, '');
  }
}
